// src/components/Header.js

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../assets/logo.png'; 
import { BsInstagram, BsYoutube } from 'react-icons/bs';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="header">
            <div className="logo-container">
                <Link to="/" className="logo-link">
                    <img src="/portrait.jpg" alt="Artisan Électricien" className="profile-pic" />
                    <img src={logoImage} alt="TechniServices Logo" className="logo-image" />
                    <strong className="logo-text">TechniServices</strong>
                </Link>
            </div>

            <nav className="nav">
                <div className="hamburger-menu" onClick={toggleMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>

                <ul className={`nav-list ${isMenuOpen ? 'open' : ''}`}>
                    <li><Link to="/" onClick={() => { if(isMenuOpen) toggleMenu(); window.scrollTo({top: 0, behavior: 'smooth'}); }}>Accueil</Link></li>
                    <li><a href="/#services" onClick={toggleMenu}>Services</a></li>
                    <li><a href="/#pourquoi" onClick={toggleMenu}>À Propos</a></li>
                    <li><a href="/#testimonials" onClick={toggleMenu}>Avis</a></li>
                    <li className="header-social-buttons">
                        <a href="https://www.instagram.com/techniservices.re/" target="_blank" rel="noopener noreferrer" className="instagram-animated-btn">
                            <BsInstagram className="icon" />
                        </a>
                        <a href="https://www.youtube.com/@TechniServices974" target="_blank" rel="noopener noreferrer" className="youtube-animated-btn">
                            <BsYoutube className="icon" />
                        </a>
                    </li>
                    <li className="mobile-cta-item">
                        <a href="/#devis" className="cta-button" onClick={toggleMenu}>Demander un Devis</a>
                    </li>
                </ul>
                
                <a href="/#devis" className="cta-button desktop-only">Demander un Devis</a>
            </nav>
        </header>
    );
};

export default Header;